var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.44346 8C2.44346 11.0688 4.93121 13.5565 8 13.5565C11.0688 13.5565 13.5565 11.0688 13.5565 8C13.5565 4.93121 11.0688 2.44346 8 2.44346C4.93121 2.44346 2.44346 4.93121 2.44346 8Z",
    fill: "#FEECBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.45039 8C2.45039 11.065 4.93504 13.5496 8 13.5496C11.065 13.5496 13.5496 11.065 13.5496 8C13.5496 4.93504 11.065 2.45039 8 2.45039C4.93504 2.45039 2.45039 4.93504 2.45039 8Z",
    fill: "#CC5C08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullProgress);
export default __webpack_public_path__ + "static/media/fullProgress.13d3d716310e9339048b9d9eeb38269f.svg";
export { ForwardRef as ReactComponent };